export const SORT_ARGS = {
  ORDERING: 'ordering',
};
